import { useContext } from 'react';

import { UserContext } from 'client/common/contexts';

export function useUser() {
    return useContext(UserContext);
}
